import _regeneratorRuntime from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { couponList } from "@/api/data";
export var coupon = {
  namespaced: true,
  state: {
    isInit: 0,
    couponKv: {}
  },
  mutations: {
    setCouponKv: function setCouponKv(state, couponMap) {
      state.isInit = 1;
      state.couponKv = couponMap;
    }
  },
  actions: {
    getCoupons: function getCoupons(_ref) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var commit, state, res, couponMap;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              commit = _ref.commit, state = _ref.state;
              if (!(state.isInit == 0)) {
                _context.next = 6;
                break;
              }
              _context.next = 4;
              return couponList();
            case 4:
              res = _context.sent;
              if (res.code == 0) {
                couponMap = {};
                res.data.forEach(function (val) {
                  couponMap[val.couponId] = val.couponName;
                });
                commit("setCouponKv", couponMap);
              }
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    }
  },
  //派生状态
  getters: {
    couponMap: function couponMap(state) {
      return state.couponKv;
    }
  }
};